module.exports = __webpack_public_path__ + "8e838bb7dff559857affdb45ed5f9bd8.png";